/**
 * @author Hadeer Elbanna
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-10-19 11:58:40
 * @description Implementation of the vision react component
 * @filename  Vision-panel.tsx
 */
import React from "react";
import ProgressiveImage from "react-progressive-image";
import { RelayProps } from "../../../relay/relay-props";
const DEFAULT_IMAGE: string = require("../../../../static/GrayColor.jpg");

interface VisionPanelProps extends RelayProps {
  json: {
    title?: string;
    description?: string;
    img?: {
      mediaAsset: any;
      link: string;
    };
  };
}

const bullseye: React.ReactNode = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 585.16 609.43"
    className="ourVision"
  >
    <g id="Layer_2" />
    <g id="Layer_1">
      <g>
        <path
          className="st0"
          d="M296.63,522.5c-27.42,0-54.03-5.37-79.08-15.97c-24.19-10.23-45.92-24.88-64.57-43.53
c-18.65-18.65-33.3-40.38-43.53-64.57c-10.6-25.06-15.97-51.66-15.97-79.08s5.37-54.03,15.97-79.08
c10.23-24.19,24.88-45.92,43.53-64.57c18.65-18.65,40.38-33.3,64.57-43.53c25.06-10.6,51.66-15.97,79.08-15.97
c27.42,0,54.03,5.37,79.08,15.97c24.19,10.23,45.92,24.88,64.57,43.53c18.65,18.65,33.3,40.38,43.53,64.57
c10.6,25.05,15.97,51.66,15.97,79.08s-5.37,54.03-15.97,79.08c-10.23,24.19-24.88,45.92-43.53,64.57
c-18.65,18.65-40.38,33.3-64.57,43.53C350.66,517.13,324.05,522.5,296.63,522.5z M296.63,145.97
c-95.61,0-173.39,77.78-173.39,173.39c0,95.61,77.78,173.39,173.39,173.39c95.61,0,173.39-77.78,173.39-173.39
C470.02,223.75,392.24,145.97,296.63,145.97z"
        />
      </g>
      <g>
        <path
          className="st1"
          d="M296.63,428.05c-59.94,0-108.7-48.76-108.7-108.7c0-59.94,48.76-108.7,108.7-108.7s108.7,48.76,108.7,108.7
C405.33,379.29,356.57,428.05,296.63,428.05z M296.63,238.53c-44.56,0-80.82,36.25-80.82,80.82c0,44.56,36.25,80.82,80.82,80.82
s80.82-36.25,80.82-80.82C377.45,274.79,341.19,238.53,296.63,238.53z"
        />
      </g>
      <circle className="st1" cx="296.63" cy="319.35" r="40.42" />
      <g>
        <path
          className="st0"
          d="M160.29,305.57H39.91c-7.58,0-13.78,6.2-13.78,13.78s6.2,13.78,13.78,13.78h120.38
c7.58,0,13.78-6.2,13.78-13.78S167.87,305.57,160.29,305.57z"
        />
        <path
          className="st0"
          d="M553.35,305.57H432.97c-7.58,0-13.78,6.2-13.78,13.78s6.2,13.78,13.78,13.78h120.38
c7.58,0,13.78-6.2,13.78-13.78S560.93,305.57,553.35,305.57z"
        />
        <path
          className="st0"
          d="M296.63,48.85L296.63,48.85c-7.58,0-13.78,6.2-13.78,13.78v120.38c0,7.58,6.2,13.78,13.78,13.78l0,0
c7.58,0,13.78-6.2,13.78-13.78V62.63C310.41,55.05,304.21,48.85,296.63,48.85z"
        />
        <path
          className="st0"
          d="M296.63,441.91L296.63,441.91c-7.58,0-13.78,6.2-13.78,13.78v120.38c0,7.58,6.2,13.78,13.78,13.78l0,0
c7.58,0,13.78-6.2,13.78-13.78V455.69C310.41,448.11,304.21,441.91,296.63,441.91z"
        />
      </g>
    </g>
  </svg>
);
/**
 *
 * A React component that renders the   Us.
 *
 * @extends {React.Component}
 */
export class VisionPanel extends React.Component<VisionPanelProps> {
  /**
   * Constructor.
   *
   * @param { VisionPanelProps} props The props of the component.
   */
  constructor(props: VisionPanelProps) {
    super(props);
  }

  /**
   * Returns a ReactNode containing the rendered component.
   *
   * @returns {React.ReactNode} The ReactNode containing the rendered component.
   */
  render(): React.ReactNode {
    return null;
    return (
      <div className="north-star-vision">
        {this.props.json ? (
          <div className="row removeMargin">
            <div className="vision col-lg-12 col-md-12 col-sm-12 col-xs-12">
              {bullseye}

              <ProgressiveImage src={this.props.json.img.link} placeholder={DEFAULT_IMAGE}>
                {(src: any, LOADING: any, srcSetData: any) => (
                  <img
                    loading="lazy"
                    alt="visionImage"
                    className="visionImage"
                    src={src}
                    onError={(e) => DEFAULT_IMAGE}
                  />
                )}
              </ProgressiveImage>
              <div className="info">
                <h3>Our Vision</h3>
                <p>{this?.props?.json?.description}</p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
